import type { TMessages } from '@/types/TMessages'

export const messages = { label: 'Популярно сейчас' } satisfies TMessages
